import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useApp, API } from "../context";

// Returns Isaiah's equipped Command Center cosmetics (title/badge/frame/glow/
// theme/arcade boost) — ONLY for the founder child. For everyone else it's a
// no-op that returns { enabled: false }. Gated by the same per-session flag the
// Header sets after GET /founder/status, so non-founders never fetch.
// Re-fetches when the Command Center dispatches `founder:cosmetics-updated`.
export function useFounderCosmetics() {
  const { user, token } = useApp();
  const [settings, setSettings] = useState(null);
  const [reality, setReality] = useState("normal");
  const [enabled, setEnabled] = useState(false);

  const fetchSettings = useCallback(async () => {
    if (!user || !token || user.isDemo) { setEnabled(false); setSettings(null); return; }
    const key = `iw_cc_${user.id || "anon"}`;
    let flag = null;
    try { flag = sessionStorage.getItem(key); } catch (_) {}
    if (flag === "0") { setEnabled(false); setSettings(null); return; } // known non-founder
    try {
      const { data } = await axios.get(`${API}/founder/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const st = data.settings || null;
      const mode = st?.reality || "normal";
      setReality(mode);
      // Cosmetics/powers ONLY apply in the Command Universe; Normal shows the true account.
      setSettings(mode === "command" ? st : null);
      setEnabled(true);
      try { sessionStorage.setItem(key, "1"); } catch (_) {}
    } catch (e) {
      setEnabled(false);
      setSettings(null);
      if (e?.response?.status === 403) { try { sessionStorage.setItem(key, "0"); } catch (_) {} }
    }
  }, [user?.id, token, user?.isDemo]);

  useEffect(() => { fetchSettings(); }, [fetchSettings]);

  useEffect(() => {
    const h = () => fetchSettings();
    window.addEventListener("founder:cosmetics-updated", h);
    return () => window.removeEventListener("founder:cosmetics-updated", h);
  }, [fetchSettings]);

  return { enabled, settings, reality, refresh: fetchSettings };
}
